import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { Body1, Body5, Container, Page, SVG_LOADING_ICON_TYPES, SvgLoadingIcon } from '@ui';
import { useNavigate } from 'react-router';
import { useColorTheme } from '@hooks';
import { useSearchParams } from 'react-router-dom';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { ROUTES } from '@constants/routes';
import { sendApiRequest } from '@services/api';
import { logError, logNetRequest } from '@utils/usefulFuncs';

const PageWrapper = styled.div``;
const BodyWrapper = styled.div`
  padding: 24px;
`;

const fetchDocByFilename = async (filename) => {
  const URL = `v1/genai_tickers_filenames?user_uploaded=true`;
  const { status, data } = await sendApiRequest('get', URL);
  logNetRequest(status, data, URL);
  if (status === 200) {
    try {
      const docs = Object.values(data)[0];
      const foundDocs = docs.filter((d) => d.filename === filename);
      if (foundDocs.length > 0) {
        return foundDocs[0];
      }
      return null;
    } catch (e) {
      logError(e);
      return null;
    }
  } else {
    return null;
  }
};
const fetchDocById = async (id) => {
  const URL = `v1/genai_tickers_filenames?user_uploaded=true`;
  const { status, data } = await sendApiRequest('get', URL);
  logNetRequest(status, data, URL);
  if (status === 200) {
    try {
      const docs = Object.values(data)[0];
      const foundDocs = docs.filter((d) => d.id === parseInt(id, 10));
      if (foundDocs.length > 0) {
        return foundDocs[0];
      }
      return null;
    } catch (e) {
      logError(e);
      return null;
    }
  } else {
    return null;
  }
};

export const AwaitDocProcessingToDigitalAnalystMode = () => {
  const colorTheme = useColorTheme();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const filename = searchParams.get('filename');
  const fileId = searchParams.get('fid');

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    const init = async () => {
      let doc = null;
      if (filename) {
        doc = await fetchDocByFilename(filename);
      } else {
        doc = await fetchDocById(fileId);
      }
      if (doc) {
        setTimeout(() => {
          navigate(ROUTES.digitalAnalyst + `?doc-ids=${doc.id}`);
        }, 600);
      } else {
        setTimeout(() => {
          init();
        }, 500);
      }
    };
    init();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <BodyWrapper>
          <Page>
            <BackArrowButton onClick={onGoBack} />
            <Container top={40}>
              <Body1 bold>Processing {filename ? filename : 'document...'}</Body1>
            </Container>
            <Container top={48} bottom={59} row verticallyCenter>
              <SvgLoadingIcon type={SVG_LOADING_ICON_TYPES.bars} color={colorTheme.text} />
              <Container left={16}>
                <Body5>Working...</Body5>
              </Container>
            </Container>
          </Page>
        </BodyWrapper>
      </Body>
    </PageWrapper>
  );
};
